﻿{
  "registration": {
    "sectionTitle": "STRÁŽNÍ STANOVIŠTĚ",
    "title": "Registrace",
    "firstName": "Jméno",
    "lastName": "Příjmení",
    "company": "Dopravní společnost",
    "companyPlaceholder": "Zadejte 3 písmena pro vyhledávání...",
    "plate": "Registrační značka",
    "orderNumber": "Číslo objednávky",
    "photo": "Foto řidiče",
    "takePhoto": "Vyfotit",
    "chooseFile": "Vybrat soubor",
    "security": "Přečetl jsem a přijal protokol bezpečnosti areálu",
    "securitySub": "OOPP povinné · Zakázané zóny · Max. rychlost 10 km/h",
    "submit": "Potvrdit registraci",
    "success": "Registrace úspěšně dokončena",
    "qrInstruction": "Naskenujte tento QR kód pro přístup k mapě a službám areálu z telefonu nebo tabletu.",
    "qrDone": "Registrace dokončena",
    "nextRegistration": "Další registrace",
    "errorRequired": "Toto pole je povinné",
    "errorSecurity": "Musíte přijmout bezpečnostní protokol",
    "phone": "Telefonní číslo",
    "phonePlaceholder": "+420 601 123 456",
    "tankCapacity": "Kapacita cisterny (litry)",
    "tankCapacityPlaceholder": "Např. 26000",
    "baffles": "Přepážky",
    "bafflesYes": "Ano",
    "bafflesNo": "Ne",
    "tare": "Tára vozidla (kg)",
    "tarePlaceholder": "Např. 14500",
    "washCertificate": "Čisticí certifikát",
    "washWashed": "Čistá",
    "washNotWashed": "Nečistá",
    "adr": "Shoda ADR",
    "adrCompliant": "Shodný",
    "adrNotCompliant": "Neshodný",
    "groupContact": "Kontakt",
    "groupVehicle": "Vozidlo a Cisterna",
    "groupCompliance": "Shoda",
    "groupSecurity": "Bezpečnost",
    "securityProtocol": "Bezpečnostní protokol areálu",
    "groupMedia": "Média",
    "fieldOptional": "Volitelné",
    "fieldRequired": "Povinné",
    "wizardStepLabel": "Krok",
    "wizardStep1Title": "Jakou operaci provádíte?",
    "wizardStep1Subtitle": "Vyberte typ zásahu na pracovišti",
    "wizardExpedition": "Expedice",
    "wizardLivraison": "Dodávka",
    "wizardStep2Title": "Číslo objednávky",
    "wizardOrderLabel": "Číslo objednávky",
    "wizardOrderHintExpedition": "Příklad: AR… nebo 5…",
    "wizardOrderHintLivraison": "Příklad: 85…",
    "wizardOrderError": "Neplatný formát pro tento typ operace",
    "wizardOrderUnknown": "Nemám / neznám číslo objednávky",
    "wizardOrderPlanned": "Nalezena naplánovaná objednávka — pole předvyplněna",
    "wizardValidate": "Potvrdit",
    "wizardBack": "Zpět",
    "wizardStep3Title": "Jaký typ vozidla řídíte?",
    "wizardStep3Subtitle": "Vyberte své vozidlo",
    "wizardTank": "Cisterna",
    "wizardTrailer": "Návěs",
    "wizardModalIso": "ISO cisterna?",
    "wizardModalContainer": "Kontejner?",
    "wizardYes": "ANO",
    "wizardNo": "NE",
    "chassisPlate": "Číslo ISO",
    "containerPlate": "Číslo kontejneru",
    "tareIso": "ISO tara (kg)",
    "tareContainer": "Kontejnerová tara (kg)",
    "pinTitle": "PIN kód",
    "pinError": "Nesprávný kód",
    "pinCancel": "Zrušit",
    "capturePhoto": "Pořídit",
    "guardAccess": "Přístup ostrahy",
    "trailerPlate": "SPZ návěsu"
  },
  "driver": {
    "title": "Vítejte v areálu",
    "subtitle": "Postupujte podle pokynů strážního stanoviště",
    "yourPosition": "Vaše poloha",
    "enableGps": "Aktivovat polohu",
    "gpsActive": "Poloha aktivní",
    "gpsError": "Poloha není dostupná",
    "gpsPermission": "Povolte přístup k poloze",
    "helpBtn": "Potřebuji pomoc",
    "helpSent": "Žádost o pomoc odeslána",
    "helpAlready": "Vaše žádost byla přijata",
    "sessionExpired": "Relace ukončena",
    "sessionExpiredMsg": "Vaše relace vypršela. Děkujeme za návštěvu.",
    "waitingMsg": "Prosím čekejte, pracovník vám brzy pomůže",
    "estimatedPassage": "Odhadovaný čas průjezdu",
    "instruction": "Pokyn",
    "instructionClose": "Zavřít"
  },
  "incident": {
    "alertTitle": "ALARM — OKAMŽITĚ EVAKUUJTE",
    "alertSubtitle": "Okamžitě sledujte pokyny na mapě",
    "alertInstruction": "Přejděte na nejbližší shromaždiště",
    "safeNow": "Jsem v bezpečí",
    "normalMode": "Situace se vrátila do normálu",
    "evacuation": "Evakuační bod",
    "assembly": "Shromaždiště",
    "firstAid": "První pomoc"
  },
  "messages": {
    "title": "Zpráva od operátora",
    "placeholder": "Napište zprávu řidiči...",
    "send": "Odeslat",
    "dictate": "Diktovat",
    "translatedTo": "Přeloženo do",
    "noMessages": "Žádné zprávy nebyly odeslány",
    "reactionSent": "Reakce odeslána"
  }
}
